import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { vendor as vendorApi } from '../../../api';
import { VendorDetailContext } from '../../../contexts';
import { useApi, useAuth } from '../../../hooks';
import { VendorTaxInformationSchema } from '../../../schemas/Vendor';
import { PermissionKey } from '../../../types';
import { EditCardSkeleton } from '../../Card';
import { TaxInformationForm } from './TaxInformationForm';

export const TaxInformationAdmin = () => {
  const { hasPermissions } = useAuth();
  const { t } = useTranslation();
  const { vendor, vendorId } = useContext(VendorDetailContext);
  const { data, isLoading, refresh } = useApi(vendorApi.getTaxInformation, null, vendorId);
  const { call } = useApi(vendorApi.updateTaxInformation, { successKey: 'common:success.save' });

  return (
    <EditCardSkeleton
      readOnly={!hasPermissions(PermissionKey.VendorEditFinancial)}
      entity={data}
      isLoading={isLoading}
      title={t('vendor:financials.sections.taxInformation')}
      disabled={vendor?.isArchived}
      schema={VendorTaxInformationSchema()}
      onSave={call}
      onConfirm={() => refresh()}
      showModifiedDate
    >
      <TaxInformationForm />
    </EditCardSkeleton>
  );
};
